<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{
            $t(
              'school.academic.operation.profile_mgt.teacher_profile.employee_profile'
            )
          }}
        </h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <ts-branch-filter
            @filter="value => (branch_id = value)"
            class="ts-w-full"
          />
          <ts-input
            class="form-control d-block mb-2"
            v-model="searchText"
            :placeholder="$t('Search')"
          />
        </div>
        <div class="overflow-auto" style="max-height: 500px; min-height: 400px">
          <ts-table :loading="loading" :columns="columns" :records="employees">
            <template v-slot="{ record }">
              <td class="text-center ts-whitespace-no-wrap">
                <a
                  href="#"
                  title="Add To Profile"
                  class="text-primary"
                  @click.prevent="select(record)"
                >
                  <i class="fas fa-plus"></i>
                </a>
              </td>
              <td>{{ record.branch ? record.branch.branch_name_en : '' }}</td>
              <td>{{ record.emp_id }}</td>
              <td>{{ record.name_en }}</td>
              <td>{{ record.name_kh }}</td>
              <td class="text-center ts-whitespace-no-wrap">
                <span v-if="record.gender == 1">{{
                  $t('teacherprofile.male')
                }}</span>
                <span v-else>{{ $t('teacherprofile.female') }}</span>
              </td>
              <td>{{ record.phone_number_1 }}</td>
              <td class="ts-whitespace-no-wrap">
                {{ record.position ? record.position.pos_name_en : '' }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{
                  record.shift
                    ? record.shift.shift_name +
                      ' (' +
                      record.shift.shift_type +
                      ')'
                    : ''
                }}
              </td>
            </template>
          </ts-table>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'Employee',
  props: ['value'],
  data() {
    return {
      branch_id: [],
      model: {},
      searchText: '',
      employees: [],
      loading: false
    }
  },
  computed: {
    columns() {
      return [
        {
          name: ''
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.branch'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.id'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.name_en'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.name_kh'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.gender'
          ),
          style: 'text-align:center;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.phone'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.position'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.shift_name'
          )
        }
      ]
    }
  },
  created() {
    this.fetchEmployee()
  },
  methods: {
    fetchEmployee(attributes) {
      this.loading = true
      this.$store
        .dispatch('teacherProfile/fetchEmolyee', attributes)
        .then(response => {
          this.employees = response.data
          this.model = this.value
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    select(record) {
      this.model.teacher_code = record.emp_id
      this.model.lname_native = record.name_kh
        ? record.name_kh.split(' ')[0]
        : ''
      this.model.fname_native = record.name_kh
        ? record.name_kh.substring(record.name_kh.split(' ')[0].length).trim()
        : ''
      this.model.lname_foreign = record.name_en
        ? record.name_en.split(' ')[0]
        : ''
      this.model.fname_foreign = record.name_en
        ? record.name_en.substring(record.name_en.split(' ')[0].length).trim()
        : ''
      this.model.gender = record.gender
      this.model.id_card_no = record.id_number
      this.model.dob = record.date_of_birth
      this.model.phone = record.phone_number_1
      this.model.email = record.email
      this.model.teacher_status = record.marital_status
      this.model.photo = record.photo
      this.model.shift_id = record.shift_id
      this.model.position_id = record.position_id
      this.model.ref_staff_id = record.staff_id

      this.loadAddress(
        record.province_code,
        record.district_code,
        record.commune_code,
        record.village_code
      ).then(() => {
        this.$emit('close')
      })
    },

    loadAddress(provinceCode, districtCode, communeCode, villageCode) {
      return new Promise(resolve => {
        this.clearAddress()
        this.model.province_code = provinceCode
        this.$nextTick(() => {
          this.model.district_code = districtCode
          this.$nextTick(() => {
            this.model.commune_code = communeCode
            this.$nextTick(() => {
              this.model.village_code = villageCode
              resolve()
            })
          })
        })
      })
    },

    clearAddress() {
      this.model.district_code = ''
      this.model.commune_code = ''
      this.model.village_code = ''
    }
  },
  watch: {
    searchText: debounce(function() {
      this.fetchEmployee({ search: this.searchText, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchEmployee({ branch_id: value, search: this.searchText })
    }, 500)
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  background: rgba(230, 230, 230, 1);
  z-index: 10;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
